import React, { useState, useEffect } from "react";
import toast from "react-hot-toast";
const API = "https://api.ctexpresskh.com/api";

export default function AppVersion() {
  const [android, setAndroid] = useState({ min_version:'1.0.0', latest_version:'1.0.0', force_update:false, message:'Please update to continue', update_url:'' });
  const [ios, setIos] = useState({ min_version:'1.0.0', latest_version:'1.0.0', force_update:false, message:'Please update to continue', update_url:'' });
  const token = localStorage.getItem("token");

  useEffect(() => { load(); }, []);

  const load = async () => {
    try {
      const [r1, r2] = await Promise.all([
        fetch(API + "/mobile/version/android").then(r => r.json()),
        fetch(API + "/mobile/version/ios").then(r => r.json()),
      ]);
      if (r1.success) setAndroid(r1.data);
      if (r2.success) setIos(r2.data);
    } catch {}
  };

  const save = async (platform, data) => {
    try {
      const res = await fetch(API + "/settings/app-version", {
        method: "PUT",
        headers: { "Content-Type": "application/json", Authorization: "Bearer " + token },
        body: JSON.stringify({ platform, ...data })
      });
      const d = await res.json();
      if (d.success) toast.success(`${platform} version saved!`);
      else toast.error(d.message);
    } catch { toast.error("Error saving"); }
  };

  const VersionForm = ({ label, data, setData, platform }) => (
    <div style={{ backgroundColor:'#fff', borderRadius:12, border:'1px solid #e5e7eb', padding:24, marginBottom:20 }}>
      <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:20 }}>
        <div>
          <h3 style={{ margin:0, fontSize:16, fontWeight:700 }}>{label}</h3>
          <p style={{ margin:'4px 0 0', fontSize:12, color:'#6b7280' }}>Current: v{data.latest_version} | Min: v{data.min_version}</p>
        </div>
        <div style={{ display:'flex', alignItems:'center', gap:8 }}>
          <span style={{ fontSize:13, color:'#374151', fontWeight:600 }}>Force Update</span>
          <div onClick={() => setData(d => ({...d, force_update:!d.force_update}))}
            style={{ width:44, height:24, borderRadius:12, backgroundColor: data.force_update ? '#dc2626':'#e5e7eb', cursor:'pointer', position:'relative', transition:'0.2s' }}>
            <div style={{ position:'absolute', top:2, left: data.force_update ? 22:2, width:20, height:20, borderRadius:10, backgroundColor:'#fff', transition:'0.2s' }} />
          </div>
        </div>
      </div>
      <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:16, marginBottom:16 }}>
        <div>
          <label style={{ fontSize:12, fontWeight:600, color:'#374151', display:'block', marginBottom:4 }}>Minimum Version</label>
          <input value={data.min_version} onChange={e => setData(d => ({...d, min_version:e.target.value}))}
            placeholder="1.0.0" style={{ width:'100%', padding:'8px 12px', border:'1px solid #d1d5db', borderRadius:8, fontSize:14, boxSizing:'border-box' }} />
          <p style={{ fontSize:11, color:'#6b7280', margin:'4px 0 0' }}>Users below this version will be forced to update</p>
        </div>
        <div>
          <label style={{ fontSize:12, fontWeight:600, color:'#374151', display:'block', marginBottom:4 }}>Latest Version</label>
          <input value={data.latest_version} onChange={e => setData(d => ({...d, latest_version:e.target.value}))}
            placeholder="1.0.0" style={{ width:'100%', padding:'8px 12px', border: '1px solid #d1d5db', borderRadius:8, fontSize:14, boxSizing:'border-box' }} />
        </div>
        <div>
          <label style={{ fontSize:12, fontWeight:600, color:'#374151', display:'block', marginBottom:4 }}>Update Message</label>
          <input value={data.message} onChange={e => setData(d => ({...d, message:e.target.value}))}
            placeholder="Please update to continue" style={{ width:'100%', padding:'8px 12px', border:'1px solid #d1d5db', borderRadius:8, fontSize:14, boxSizing:'border-box' }} />
        </div>
        <div>
          <label style={{ fontSize:12, fontWeight:600, color:'#374151', display:'block', marginBottom:4 }}>Store URL</label>
          <input value={data.update_url||''} onChange={e => setData(d => ({...d, update_url:e.target.value}))}
            placeholder="https://play.google.com/store/..." style={{ width:'100%', padding:'8px 12px', border:'1px solid #d1d5db', borderRadius:8, fontSize:14, boxSizing:'border-box' }} />
        </div>
      </div>
      {data.force_update && (
        <div style={{ backgroundColor:'#fee2e2', borderRadius:8, padding:'10px 14px', marginBottom:16, fontSize:13, color:'#dc2626', fontWeight:600 }}>
          ⚠️ Force update is ON — users below v{data.min_version} will be forced to update!
        </div>
      )}
      <button onClick={() => save(platform, data)}
        style={{ backgroundColor:'#dc2626', color:'#fff', border:'none', borderRadius:8, padding:'10px 24px', fontWeight:700, cursor:'pointer' }}>
        💾 Save {label} Settings
      </button>
    </div>
  );

  return (
    <div style={{ padding:24 }}>
      <div style={{ marginBottom:24 }}>
        <h2 style={{ margin:0, fontSize:22, fontWeight:700 }}>📱 App Version Control</h2>
        <p style={{ margin:'4px 0 0', color:'#6b7280', fontSize:13 }}>Control force updates for Android and iOS</p>
      </div>
      <VersionForm label="🤖 Android" data={android} setData={setAndroid} platform="android" />
      <VersionForm label="🍎 iOS" data={ios} setData={setIos} platform="ios" />
    </div>
  );
}
